import ProductHelpersMixin from "../../mixins/ProductHelpersMixin"
import CartHelpersMixin from "../../mixins/CartHelpersMixin"
import { currencyFormat, notify, successNotify, errorNotify } from "../../functions"
import store from "../../store"

export default {
  mixins: [
    CartHelpersMixin,
    ProductHelpersMixin
  ],
  data() {
    return {
      shippingMethodName: null,
      paymentMethodName: null,
      crossSellProducts: [],
      currencyFormat,
      notify,
      successNotify,
      errorNotify
    }
  },
  computed: {
    hasAnyCrossSellProduct() {
      return this.crossSellProducts.length !== 0
    }
  },
  created() {
    this.$nextTick(() => {
      if (store.state.cart.shippingMethodName) {
        this.changeShippingMethod(store.state.cart.shippingMethodName)
      } else {
        this.updateShippingMethod(this.firstShippingMethod)
      }

      if (store.state.cart.paymentMethodName) {
        this.changePaymentMethod(store.state.cart.paymentMethodName)
      } else {
        this.updatePaymentMethod(this.firstPaymentMethod)
      }
    })
  },
  methods: {
    optionValues(option) {
      let values = []

      for (let value of option.values) {
        values.push(value.label)
      }

      return values.join(", ")
    },
    updateQuantity(cartItem, qty) {
      var that = this
      that.getSB(qty, cartItem, true)
    },
    updatePrice(cartItem, price) {
      store.updateCart(cartItem, price)
    },
    exceedsMaxStock(cartItem, qty) {
      return cartItem.product.manage_stock && cartItem.product.qty < qty
    },
    remove(cartItem) {
      this.loadingOrderSummary = true

      store.removeCartItem(cartItem)

      if (store.cartIsEmpty()) {
        this.crossSellProducts = []
      }

      $.ajax({
        method: "DELETE",
        url: route("cart.items.destroy", { cartItemId: cartItem.id })
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    clearCart() {
      store.clearCart()

      if (store.cartIsEmpty()) {
        this.crossSellProducts = []
      }

      $.ajax({
        method: "POST",
        url: route("cart.clear.store")
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      })
    },
    changeShippingMethod(shippingMethodName) {
      this.shippingMethodName = shippingMethodName
    },
    changePaymentMethod(paymentMethodName) {
      this.paymentMethodName = paymentMethodName
    },
    getSB(qty, cartItem = null, storeCart = false) {
      if (storeCart == true)
        this.storeCart(cartItem, qty)
      return this.maxSellingQty
    },
    debounce(callback, delay) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(callback, delay)
    },
    updateCartQuantity(cartItem, qty) {
      this.qty = qty
      this.productQty = qty
      var that = this
      that.getSB(qty, cartItem, true)
    },
    storeCart(cartItem, qty) {

      if (qty < 1 || this.exceedsMaxStock(cartItem, qty)) {
        return
      }

      if (isNaN(qty)) {
        qty = 1
      }

      this.loadingOrderSummary = true
      qty = qty > this.maxSellingQty ? this.maxSellingQty : qty
      cartItem.qty = qty

      $.ajax({
        method: "PUT",
        url: route("cart.items.update", { cartItemId: cartItem.id }),
        data: { qty: qty || 1 }
      }).then((cart) => {
        store.updateCart(cart)
      }).catch((xhr) => {
        errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    handleInput(cartItem, value) {
      // Sanitize the input: if it's empty or not a number, set to '0'
      const sanitizedValue = value.trim() === "" || isNaN(parseFloat(value)) ? "0" : value

      // Update the local component state (which is bound to the input field)
      cartItem.unitPrice.inCurrentCurrency.formatted = sanitizedValue

      // Optionally, call storeCartPrice or any other method if you need to perform additional actions
      this.storeCartPrice(cartItem, sanitizedValue)
    },
    updateMSP(product, newValue) {
      if (newValue < product.cost.inCurrentCurrency.formatted)
        return alert("MSP can not be lower than cost (" + product.cost.inCurrentCurrency.formatted + ")")
      else {
        this.updateProduct(product.id, { msp: newValue })
      }
    },
    updateSB(product, newValue) {
      this.updateProduct(product.id, { sb_remaining_qty: newValue })
    },
    updateProduct(productId, data) {
      this.loadingOrderSummary = true
      $.ajax({
        method: "PUT",
        url: route("cart.product.update", { id: productId }),
        data
      }).then(() => {
        successNotify("Product data updated successfully")
      }).catch((xhr) => {
        console.log("error message", xhr.responseJSON.message)
        alert(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    },
    storeCartPrice(cartItem, price) {
      this.loadingOrderSummary = true
      $.ajax({
        method: "PUT",
        url: route("cart.items.update", { cartItemId: cartItem.id }),
        data: { price: price }
      }).then((cart) => {
        store.updateCart(cart)
        errorNotify("Product price updated successfully")
      }).catch((xhr) => {
        console.log("error message", xhr.responseJSON.message)
        errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.loadingOrderSummary = false
      })
    }
  }
}
